import { routes } from "@constants/routes";
import { JobPositionCard, Pagination, Typography } from "@cpj-ai/panel-npm-package";
import { GetJobPositionsQuery } from "@graphql/generated";
import { useNavigate } from "react-router-dom";

interface JobPositionListProps {
  jobPositions?: GetJobPositionsQuery;
  totalCount?: number | null;
  currentPage: number;
  isLoading: boolean;
  onPageChange: (newPage: number) => void;
  onPageSizeChange?: (newPageSize: number) => void;
}

const JobPositionList: React.FC<JobPositionListProps> = ({
  jobPositions,
  totalCount,
  currentPage,
  isLoading,
  onPageChange,
  onPageSizeChange,
}) => {
  const jobPositionsList = jobPositions?.organization?.jobPosition?.list?.edges?.map((item) => ({ ...item?.node }));
  const navigate = useNavigate();
  const navigateToJobPosition = (jobPositionId: string) => {
    navigate(routes.jobPositions.view.replace(":id", jobPositionId));
  };
  return (
    <div className="h-fit w-full flex flex-col gap-3">
      <Typography variant="small">Job listings:</Typography>
      {jobPositionsList?.length ? (
        <>
          {jobPositionsList?.map((jobPosition, index) => (
            <JobPositionCard key={index} jobPosition={jobPosition} onPress={navigateToJobPosition} />
          ))}
          {!isLoading && jobPositionsList.length > 0 && (
            <div className="flex justify-center mt-4">
              <Pagination
                total={totalCount ?? 0}
                page={currentPage}
                pageSize={10}
                onChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
              />
            </div>
          )}
        </>
      ) : (
        <div className="pt-40 w-full flex justify-center items-center">
          <Typography variant="muted">There is no job post </Typography>
        </div>
      )}
    </div>
  );
};

export default JobPositionList;
